import { getInternalWebsitePath, appendPath } from '@bizzabo/whitelabel-utils';

// Matches the server's /api/remote-section route; the adapter defaults to web-dashboard's.
export function buildRemoteSectionUrl(section) {
    return appendPath(
        getInternalWebsitePath(section.event),
        `/api/remote-section/${section.event.id}/${section.id}/${section.layoutVersionKey}`
    );
}

export function buildRemoteSectionConfigUrl(section) {
    return `${buildRemoteSectionUrl(section)}/config`;
}

export function buildEventThemeUrl(event) {
    return appendPath(getInternalWebsitePath(event), `/api/remote-section/${event.id}/theme`);
}
